module.exports = __webpack_public_path__ + "static/pattern-indicator-dashboard-7f1685fbc8cd7ce5e11ea1ae893c0d18.png";